module.exports = __webpack_public_path__ + "img/f498b2e.png";